module.exports = __webpack_public_path__ + "img/ai-icon.a66551cc.svg";